// ProtectedRoute.jsx - Checks authentication before allowing access
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "./UserContextPersistent";

const ProtectedRoute = ({ children }) => {
  const { state } = useUser();
  const location = useLocation();

  // Check if user is authenticated
  if (!state.isAuthenticated || !state.user) {
    if (location.pathname !== "/" && location.pathname !== "/login") {
      const fullPath = location.pathname + (location.search || "");
      sessionStorage.setItem("redirectUrl", fullPath);
      localStorage.setItem("redirectUrl", fullPath);
      return <Navigate to={`/login?redirect=${encodeURIComponent(fullPath)}`} state={{ from: location }} replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
